module.exports = __webpack_public_path__ + "static/UntitledSansWeb-Regular-5f7582c1bd0a728bc0427e3c22258a30.woff2";